import type { WallBoard, WallCard } from '@walls/store';
import { CircleCard } from './CircleCard';
import { RectangleCard } from './RectangleCard';
import { TriangleCard } from './TriangleCard';
import { getCardShape } from './utils/cardDisplay';

interface BoardCardProps {
  board: WallBoard;
  card: WallCard;
  measureDependencies?: unknown[];
  isClusterChild?: boolean;
}

export function BoardCard({
  board,
  card,
  measureDependencies = [],
  isClusterChild = false,
}: BoardCardProps) {
  const cardShape = getCardShape(card);

  if (cardShape === 'circle') {
    return (
      <CircleCard
        board={board}
        card={card}
        isClusterChild={isClusterChild}
        measureDependencies={measureDependencies}
      />
    );
  }

  if (cardShape === 'triangle') {
    return (
      <TriangleCard
        board={board}
        card={card}
        isClusterChild={isClusterChild}
        measureDependencies={measureDependencies}
      />
    );
  }

  return (
    <RectangleCard
      board={board}
      card={card}
      isClusterChild={isClusterChild}
      measureDependencies={measureDependencies}
      rounded={cardShape === 'rounded'}
    />
  );
}
